'use client';

import { useEffect, useState } from 'react';
import { Section } from '../../../interfaces';

interface AccordionStateHook {
  openIds: string[];
  setOpenIds: React.Dispatch<React.SetStateAction<string[]>>;
}

export const useAccordionState = (
  sections: Section[],
  onSectionOpened?: (section: Section) => void,
): AccordionStateHook => {
  const [openIds, setOpenIds] = useState<string[]>([]);

  useEffect(() => {
    openIds.forEach((id) => {
      const s = sections.find((x) => x.id === id);
      if (s) onSectionOpened?.(s);
    });
  }, [openIds, sections, onSectionOpened]);

  useEffect(() => {
    if (sections.length === 0) return;
    const first = sections[0];
    setOpenIds((prev) => (prev.includes(first.id) ? prev : [...prev, first.id]));
  }, [sections]);

  return { openIds, setOpenIds };
};
